// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3ZE5u","label":"Completed_label__p8HGQ"};